import { HssItem } from "./hss-item";

export class SequenceSummary {
  greaterTime = new HssItem("PayCreditGreaterTime");
  payCreditActual = new HssItem("PayCreditActualSeqCredit");
  payCreditDisplayed = new HssItem(null);
  totalPay = new HssItem(null);
}
